<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-toolbar flat dense class="toolbar">
      <v-toolbar-title>Qualification Details</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
    <v-data-table :headers="headers" :items="instructor_academics_list" class="elevation-1 mytable" dense
      :search="search">
      <template v-slot:top>
        <v-toolbar flat dense color="white">
          <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn class="button" v-on="on" small>Add Qualification Details</v-btn>
            </template>
            <v-card>
              <v-card-title class="toolbar">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-autocomplete dense rounded outlined :items="degree_list" item-text="degree_name"
                        item-value="degree_id" v-model="degree_name" label="Degree"
                        placeholder="Select Degree"></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-autocomplete dense rounded outlined :items="degree_list" item-text="degree_name"
                        v-model="degree_name" label="Degree"></v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field dense rounded outlined v-model="specialization"
                        label="Specialization"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field dense rounded outlined v-model="specialization"
                        label="Specialization"></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-autocomplete dense rounded outlined :items="erp_class_list" item-text="grade"
                        item-value="erp_class_id" v-model="grade" label="Class"
                        placeholder="Select Class"></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-autocomplete dense rounded outlined :items="erp_class_list" item-text="grade" v-model="grade"
                        label="Class"></v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field dense type="number" rounded outlined v-model="cpi_marks"
                        label="Percentage/CPI"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field dense type="number" rounded outlined v-model="cpi_marks"
                        label="Percentage/CPI"></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field dense rounded outlined v-model="institute_name"
                        label="Institute Name"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field dense rounded outlined v-model="institute_name"
                        label="Institute Name"></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field dense rounded outlined v-model="university" label="University"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field dense rounded outlined v-model="university" label="University"></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field dense rounded outlined v-model="yearofpassing"
                        label="Year Of Passing"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field dense rounded outlined v-model="yearofpassing"
                        label="Year Of Passing"></v-text-field>
                    </v-col>

                    <v-col cols="6" class="d-flex align-center">
                      <v-file-input v-model="file" label="Upload Document" show-size dense rounded outlined
                        :prepend-icon="null" prepend-inner-icon="mdi-paperclip" class="flex-grow-1"/>

                      <v-avatar size="28" class="ml-2 mb-5" v-if="existingFilePath && editedIndex > -1">
                        <v-icon color="primary" @click="previewDocument(existingFilePath)">
                          mdi-eye
                        </v-icon>
                      </v-avatar>

                      <v-avatar size="28" class="ml-1 mb-5" v-if="existingFilePath && editedIndex > -1">
                        <v-icon color="error" @click="deleteFile">
                          mdi-delete
                        </v-icon>
                      </v-avatar>
                    </v-col>

                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="button" @click="close">Cancel</v-btn>
                <v-btn class="button" @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon color="error" class="delete-v-icon mr-2" @click="deleteItem(item)">delete</v-icon>
          </v-avatar>
        </div>
      </template>
      <template v-slot:item.file_path="{ item }">
        <v-icon v-if="item.file_path" color="primary" small style="cursor:pointer"
          @click="previewDocument(item.file_path)">
          mdi-eye
        </v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="previewDialog" max-width="900px">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>Document Preview</span>
          <v-btn icon @click="previewDialog = false">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />
        <v-card-text class="text-center">
          <v-img v-if="isImage(previewFileUrl)" :src="previewFileUrl" max-height="450" contain />
          <embed v-else :src="previewFileUrl" type="application/pdf" width="100%" height="450" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait..
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: {
    instid: Number,
  },
  data() {
    return {
      overlay: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      dialog: false,
      dialog_upload: false,
      previewDialog: false,
      previewFileUrl: null,
      errorMsg: {
        degree_name: false,
      },
      headers: [
        {
          text: "Sr. No.",
          align: "left",
          sortable: false,
          value: "srno",
        },
        {
          text: "Degree",
          align: "left",
          sortable: false,
          value: "degree_name",
        },
        {
          text: "Specialization",
          align: "left",
          sortable: false,
          value: "specialization",
        },
        {
          text: "Grade",
          align: "left",
          sortable: true,
          value: "grade",
        },
        {
          text: "Percentage/CPI",
          align: "left",
          sortable: true,
          value: "cpi_marks",
        },
        {
          text: "Institute Name",
          align: "left",
          sortable: true,
          value: "institute_name",
        },
        {
          text: "University",
          align: "left",
          sortable: true,
          value: "university",
        },
        {
          text: "Year Of Passing",
          align: "left",
          sortable: true,
          value: "yearofpassing",
        },
        {
          text: "Document",
          align: "center",
          sortable: true,
          value: "file_path",
        },
        { text: "Actions", value: "action", sortable: false },
      ],
      editedIndex: -1,
      instructor_academics_list: [],
      degree_list: [],
      erp_class_list: [],
      instid: this.instid,
      degree_name: null,
      specialization: null,
      grade: null,
      cpi_marks: null,
      institute_name: null,
      university: null,
      yearofpassing: null,
      id: "",
      file: null,
      basepath: null,
      selectedFile: null,
      existingFilePath: null,
    };
  },
  watch: {
    instid() {
      this.getData();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Qualification Details"
        : "Edit Qualification Details";
    },
  },
  mounted() {
    this.getData();
    this.basepath = localStorage.getItem("awspath") || "";
  },
  methods: {
    getData() {
      const formData = {
        instid: this.instid,
      };
      axios
        .post("/EmployeeProfile/getEmployeeQualification", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.instructor_academics_list = res.data.instructor_academics_list;
            this.degree_list = res.data.degree_list;
            this.erp_class_list = res.data.erp_class_list;
          } else {
            // alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          // this.comp_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.instructor_academics_list.indexOf(item);
      this.degree_name = item.degree_name;
      this.specialization = item.specialization;
      this.grade = item.grade;
      // this.grade = item.erp_class_id
      this.cpi_marks = item.cpi_marks;
      this.institute_name = item.institute_name;
      this.university = item.university;
      this.yearofpassing = item.yearofpassing;
      this.id = item.id;
      // this.editedItem = Object.assign({}, item);
      this.existingFilePath = item.file_path || null
      this.file = null
      this.dialog = true;
    },
    isValidated() {
      if (this.degree_name) {
        return true;
      } else {
        if (!this.degree_name) {
          this.errorMsg.degree_name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
    save() {
      if (this.editedIndex > -1) {
        // if (this.isValidated()) {
        //   this.dialog_upload = true
        //   const formData = {
        //     instid: this.instid,
        //     degree_name: this.degree_name,
        //     specialization: this.specialization,
        //     grade: this.grade,
        //     cpi_marks: this.cpi_marks,
        //     institute_name: this.institute_name,
        //     university: this.university,
        //     yearofpassing: this.yearofpassing,
        //     id: this.id,
        //   };
        //   axios
        //     .post("/EmployeeProfile/editEmployeeQualification", formData)
        //     .then((res) => {
        //       if (res.data.msg == "200") {
        //         if (res.data.status.code == "SUCCESS") {
        //           this.showSnackbar(
        //             "#4caf50",
        //             "Academics updated successfully..."
        //           );
        //         } else {
        //           this.showSnackbar("#b71c1c", "Academics already present!!!");
        //         }
        //         // Object.assign(
        //         //   this.instructor_academics_list[this.editedIndex],
        //         //   this.editedItem
        //         // );
        //         // show snackbar on success
        //       }
        //       this.getData();
        //       this.dialog_upload = false
        //     })
        //     .catch((error) => {
        //       this.showSnackbar("#b71c1c", "Something went wrong!!!");
        //       window.console.log(error);
        //     })
        //     .finally(() => {
        //       this.degree_name = null;
        //       this.specialization = null;
        //       this.grade = null;
        //       this.cpi_marks = null;
        //       this.institute_name = null;
        //       this.university = null;
        //       this.yearofpassing = null;
        //     });

        //   this.close();
        // }
        if (this.editedIndex > -1) {
          if (this.isValidated()) {
            this.dialog_upload = true
            const formData = new FormData();
            formData.append("id", this.id);
            formData.append("instid", this.instid);
            formData.append("degree_name", this.degree_name);
            formData.append("specialization", this.specialization);
            formData.append("grade", this.grade);
            formData.append("cpi_marks", this.cpi_marks);
            formData.append("institute_name", this.institute_name);
            formData.append("university", this.university);
            formData.append("yearofpassing", this.yearofpassing);

            if (this.file) {
              formData.append("file", this.file);
            }
            axios
              .post("/EmployeeProfile/editEmployeeQualificationAndFile", formData, {
                headers: { "Content-Type": "multipart/form-data" },
              })
              .then((res) => {
                if (res.data.code === "SUCCESS") {
                  this.showSnackbar("#4caf50", "Academics updated successfully...");
                  this.getData();
                } else {
                  this.showSnackbar("#b71c1c", "Academics already present!!!");
                }
                this.dialog_upload = false
              })
              .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                window.console.log(error);
              })
              .finally(() => {
                this.degree_name = null;
                this.specialization = null;
                this.grade = null;
                this.cpi_marks = null;
                this.institute_name = null;
                this.university = null;
                this.yearofpassing = null;
                this.file = null
              });

            this.close();
          }
        }
      }
      // else {
      //   // alert('in else'+this.addedItem.degree_name)
      //   this.dialog_upload = true
      //   const formData = {
      //     instid: this.instid,
      //     degree_name: this.degree_name,
      //     specialization: this.specialization,
      //     grade: this.grade,
      //     cpi_marks: this.cpi_marks,
      //     institute_name: this.institute_name,
      //     university: this.university,
      //     yearofpassing: this.yearofpassing,
      //     file : this.file
      //   };
      //   axios
      //     .post("/EmployeeProfile/saveEmployeeQualification", formData)
      //     .then((res) => {
      //       if (res.data.status.code == "SUCCESS") {
      //         // this.instructor_academics_list.push(this.addedItem);
      //         this.showSnackbar("#4caf50", " Academics added successfully..."); // show snackbar on success
      //         this.getData();
      //       } else if (res.data.status.code == "NA") {
      //         this.showSnackbar("#b71c1c", "Academics already present!!!"); // show snackbar on error
      //       }
      //       this.dialog_upload = false
      //     })
      //     .catch((error) => {
      //       this.showSnackbar("#b71c1c", "Something went wrong!!!");
      //       window.console.log(error);
      //     })
      //     .finally(() => {
      //       this.degree_name = null;
      //       this.specialization = null;
      //       this.grade = null;
      //       this.cpi_marks = null;
      //       this.institute_name = null;
      //       this.university = null;
      //       this.yearofpassing = null;
      //     });
      else {
        this.dialog_upload = true

        const formData = new FormData()
        formData.append("instid", this.instid)
        formData.append("degree_name", this.degree_name)
        formData.append("specialization", this.specialization)
        formData.append("grade", this.grade)
        formData.append("cpi_marks", this.cpi_marks)
        formData.append("institute_name", this.institute_name)
        formData.append("university", this.university)
        formData.append("yearofpassing", this.yearofpassing)

        if (this.file) {
          formData.append("file", this.file)
        }

        axios
          .post("/EmployeeProfile/saveEmployeeQualificationAndFile", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Academics added successfully...")
              this.getData()
            } else if (res.data.code == "NA") {
              this.showSnackbar("#b71c1c", res.data.msg || "Academics already present!!!")
            }
            this.dialog_upload = false
          })
          .catch(() => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!")
          })
          .finally(() => {
            this.degree_name = null
            this.specialization = null
            this.grade = null
            this.cpi_marks = null
            this.institute_name = null
            this.university = null
            this.yearofpassing = null
            this.file = null
          })
        this.close();
      }
    },

    deleteItem(item) {
      // alert("in delete : "+item.id)
      var result = confirm("Want to delete?");
      if (result) {
        this.dialog_upload = true
        const formData = {
          instid: this.instid,
          inst_academics_id: item.id,
        };
        axios
          .post("/EmployeeProfile/deleteEmployeeQualification", formData)
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.status.code == "SUCCESS") {
                this.showSnackbar("#4caf50", " Academics deleted successfully...");
              } else {
                this.showSnackbar("#b71c1c", "Can not delete Academics!!!");
              }
              this.getData();
            } else {
              this.showSnackbar("#b71c1c", "Please try again!!!");
            }
            this.dialog_upload = false
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          })
          .finally(() => {
            // this.comp_load = false;
          });
      }
    },

    deleteFile() {
      if(confirm("Are you sure want to delete the document?")){
      const formData = {
        instid: this.instid,
        inst_academics_id: this.id,
      };
      axios.post("/EmployeeProfile/deleteFile", formData)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", " Document deleted successfully...");
            this.existingFilePath = null;
          } else {
            this.showSnackbar("#b71c1c", res.data.msg || "Can not delete Document!!!");
          }
          this.getData();
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
      }
      this.dialog_upload = false;
    },

    close() {
      this.dialog = false;
      this.degree_name = null;
      this.specialization = null;
      this.grade = null;
      this.cpi_marks = null;
      this.institute_name = null;
      this.university = null;
      this.yearofpassing = null;
      this.editedIndex = -1;
      this.file = null;
    },

    previewDocument(filePath) {
      const path = filePath || this.existingFilePath;
      if (!path) {
        this.showSnackbar("#b71c1c", "No document available");
        return;
      }
      this.previewFileUrl = this.getFullPath(path);
      this.previewDialog = true;
    },

    getFullPath(path) {
      if (!path) return "";
      if (path.startsWith("http")) return path;
      return this.basepath+path;
    },

    isImage(url) {
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
    },

  },
};
</script>
<style scoped>

</style>